











 









const node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RemoveTeamMemberModal_teamMember",
  "selections": [
    {
      "alias": "teamMemberId",
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "preferredName",
      "storageKey": null
    }
  ],
  "type": "TeamMember",
  "abstractKey": null
};

(node ).hash = "9f1010801cd1ea7ebde1d91741f4db9a";

export default node;
